'use strict';

import throttle from './throttle.js';
import lottie from 'lottie-web';
import menuLottie from './menu.lottie.json';
import delegateEvent from './delegateEvent.js';

export default class FixedMenuHandler {
    constructor() {
        const toggleElement = document.querySelector('.w-header__toggle');
        this.animation = lottie.loadAnimation({
            container: toggleElement,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            animationData: menuLottie,
        });

        this.animationDirection = -1;
        this.animation.setDirection(this.animationDirection);

        delegateEvent(document, 'click', '[data-w-header-toggle]', () => {
            this.animationDirection *= -1;
            this.animation.pause();
            this.animation.setDirection(this.animationDirection);
            this.animation.play();
            if (this.animationDirection === -1) {
                document.documentElement.classList.remove('w-has-menu-open');
            } else {
                document.documentElement.classList.add('w-has-menu-open');
            }
        });

        document.addEventListener(
            'w.ScrollToHandler',
            () => {
                this.close();
            },
            false
        );

        // ------------------------------------

        this.current = Math.round(window.scrollY);
        this.direction = 0;
        this.boundary = 240;
        this.updateRate = 10;

        window.addEventListener(
            'scroll',
            throttle(
                function (event) {
                    const current = Math.round(window.scrollY);

                    // if down
                    if (this.current < current) {
                        this.direction = 1;
                        if (current > this.boundary) {
                            document.documentElement.classList.add(
                                'w-is-scrolled'
                            );
                            document.documentElement.classList.add(
                                'w-is-scrolled-once'
                            );
                        }

                        document.documentElement.classList.remove(
                            'w-is-scrolled-up'
                        );
                    }

                    // if up
                    else if (this.current > current) {
                        this.direction = -1;
                        if (current <= this.boundary) {
                            document.documentElement.classList.remove(
                                'w-is-scrolled'
                            );
                        }

                        document.documentElement.classList.add(
                            'w-is-scrolled-up'
                        );
                    }

                    this.current = current;
                }.bind(this),
                this.updateRate
            )
        );
    }

    close() {
        this.animationDirection = -1;
        this.animation.pause();
        this.animation.setDirection(this.animationDirection);
        this.animation.play();
        document.documentElement.classList.remove('w-has-menu-open');
    }
}
